import React from "react";
import { convertToRupiah } from "../../tools/numerictools";

export default function BillingInfo({ billingData }) {
  return (
    <div className="billing-info">
      <table>
        <tbody>
          <tr>
            <td>No. Reg</td>
            <td>{billingData.registration_number || "-"}</td>
          </tr>
          <tr>
            <td>Nama</td>
            <td>{billingData.name || "-"}</td>
          </tr>
          <tr>
            <td>Alamat</td>
            <td>
              {billingData.installation_address
                ? `
                    ${billingData.installation_address?.address} RT ${billingData.installation_address?.rt}/ RW ${billingData.installation_address?.rw}, 
                    ${billingData.installation_address?.addresses.kelurahan}, 
                    ${billingData.installation_address?.addresses.kecamatan}, 
                    ${billingData.installation_address?.addresses.kota_kab}, 
                    ${billingData.installation_address?.addresses.province}, 
                    ${billingData.installation_address?.addresses.postal_code}
                      `
                : "-"}
            </td>
          </tr>
          <tr>
            <td>Paket</td>
            <td>{billingData.internet_package?.name || "-"}</td>
          </tr>
          <tr>
            <td colSpan={2}>&nbsp;</td>
          </tr>
          {billingData.type === "CUSTOMER" ? (
            <>
              <tr>
                <td>Harga Paket</td>
                <td>Rp {convertToRupiah(billingData.amount || 0)}</td>
              </tr>
              <tr>
                <td>Denda</td>
                <td>Rp {convertToRupiah(billingData.penalty_amount || 0)}</td>
              </tr>
            </>
          ) : null}

          {billingData.type === "REGISTRATION" ? (
            <>
              <tr>
                <td>Harga Paket</td>
                <td>Rp {convertToRupiah(billingData.amount || 0)}</td>
              </tr>
              <tr>
                <td>Biaya Pemasangan</td>
                <td>
                  Rp {convertToRupiah(billingData.installation_cost || 0)}
                </td>
              </tr>
            </>
          ) : null}

          {billingData.type === "CUSTOMER-RELOCATE" ? (
            <>
              <tr>
                <td>Biaya Relokasi</td>
                <td>
                  Rp {convertToRupiah(billingData.installation_cost || 0)}
                </td>
              </tr>
            </>
          ) : null}

          {billingData.additional_amount > 0 ? (
            <tr>
              <td>Biaya Tambahan</td>
              <td>Rp {convertToRupiah(billingData.additional_amount || 0)}</td>
            </tr>
          ) : null}

          <tr>
            <td>Biaya Admin</td>
            <td>Rp {convertToRupiah(billingData.admin_fee || 0)}</td>
          </tr>
          {billingData.value_added_tax_amount > 0 ? (
            <tr>
              <td>PPN ({billingData.value_added_tax_rate}%)</td>
              <td>
                Rp {convertToRupiah(billingData.value_added_tax_amount || 0)}
              </td>
            </tr>
          ) : null}

          <tr className="font-weight-bold">
            <td>Total</td>
            <td>Rp {convertToRupiah(billingData.final_amount || 0)}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}
